export default {
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  sortBy: function sortBy(state) {
    return state.sortBy;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  previousPage: function previousPage(state) {
    return state.previousPage;
  },
  nextPage: function nextPage(state) {
    return state.nextPage;
  }
};